import React from 'react';
import { createStyles } from '@/contexts/theme-context';
import { SCREEN_PADDING, ThemedSVGProps, TYPOGRAPHY } from '@/styles';
import { StyleProp, Text, TextStyle, View, ViewStyle } from 'react-native';
import { SvgProps } from 'react-native-svg';

interface Props {
  children?: React.ReactNode;
  containerStyle?: StyleProp<ViewStyle>;
  contentStyle?: StyleProp<ViewStyle>;
  iconProps?: ThemedSVGProps;
  ImageComponent?: React.ComponentType<SvgProps>;
  text?: string | React.ReactNode;
  textStyle?: StyleProp<TextStyle>;
}

export const EmptyStateMinimal: React.FC<Props> = ({
  children,
  containerStyle,
  contentStyle,
  iconProps = {},
  ImageComponent,
  text,
  textStyle,
}) => {
  const [styles, theme] = useStyles();
  return (
    <View style={[styles.emptyStateContainer, containerStyle]}>
      <View style={[styles.content, contentStyle]}>
        {ImageComponent ? (
          <ImageComponent fill={theme.colors.accent} {...iconProps} />
        ) : null}
        {text ? (
          <Text style={[TYPOGRAPHY.medium, styles.emptyStateText, textStyle]}>
            {text}
          </Text>
        ) : null}
        {children}
      </View>
    </View>
  );
};

const useStyles = createStyles((theme) => ({
  content: {
    alignItems: 'center',
    paddingHorizontal: SCREEN_PADDING,
  },
  emptyStateContainer: {
    backgroundColor: theme.colors.background,
    flex: 1,
    justifyContent: 'center',
  },
  emptyStateText: {
    display: 'flex',
    lineHeight: 24,
    marginTop: 12,
    textAlign: 'center',
  },
}));
